<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="设备种类：" prop="device_type">
                <el-select clearable v-model="model.device_type" placeholder="请选择" style="width: 200px" disabled>
                    <el-option v-for="item in enuObj('device_type2')" :key="'device_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所需设备数量：" prop="device_count_need">
                <el-input v-model.number="model.device_count_need" :disabled="model.device_type=='3' || model.device_type=='4' || model.device_type=='5' || model.device_type=='6' || model.device_type=='7' || model.device_type=='8'" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceInfoEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                device_type: '',
                device_count: '',
                device_count_need: '',
                device_count_cha: '',
                device_count_use: '',
                order_index: '',
                remark: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/deviceinfo/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_type2'],
            rules: {
                device_type: [
                    {required: true, message: '设备种类不能为空', trigger: 'blur'},
                ],
                device_count_need: [
                    {required: true, message: '所需设备数量不能为空', trigger: 'blur'},
                    {type: 'number', message: '所需设备数量必须是数字值', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/deviceinfo/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.device_type = this.model.device_type+""
        },
    }
};
</script>